import { FC } from 'react';
import { darkColors } from '@tryhackme/thm-ui-components';
import { ThemeProvider, useTheme } from 'styled-components';
import { Countdown } from '../../components/countdown';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { StarWarsSaber } from '../star-wars-saber';
import { StyledCard, StyledSaber, StyledSubtitle, StyledTimerMessage, StyledTitle } from './star-wars-account-card.styles';
export const StarWarsAccountCard: FC = () => {
  const theme = useTheme();
  const {
    campaign
  } = useActiveCampaign();
  return campaign ? <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }}>
      <StyledCard>
        <StyledSaber>
          <StarWarsSaber red />
        </StyledSaber>
        <StyledSaber onRight>
          <StarWarsSaber />
        </StyledSaber>
        <StyledTitle>
          MAY THE 4<sup>TH</sup> BE WITH YOU
        </StyledTitle>
        <StyledSubtitle>
          Save <span>{campaign.amount}%</span> on annual subscriptions
        </StyledSubtitle>

        <StyledTimerMessage>Sale ends in:</StyledTimerMessage>
        <Countdown includeDays dark vertical startTime={campaign.startTime} endTime={campaign.endTime} />
      </StyledCard>
    </ThemeProvider> : null;
};